//Built-in libraries

//Third party libraries

//Custom components
import type { IFilterBadge } from '@/components/FilterBadgesList';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import Modal from '@/components/UI/Modal';
import { statusChangeList } from '@/constants/Rover/Applications/index';

//Services

//STP Libraries

//Assets and Miscellaneous
import type { QueryParamsInterface } from '@/types/Shared';

//Component Begin

interface ICHDOFiltersFormProps {
  handleModal: () => void;
  handleApplyFilter: (filterData: QueryParamsInterface, filterBadgesData?: IFilterBadge) => void;
}

export interface StatusList {
  label: string;
  value: string;
}

const CHDOFiltersBaseForm = ({ handleModal, handleApplyFilter }: ICHDOFiltersFormProps) => {
  const onSubmit = (formData: { status: StatusList }) => {
    const applyFiltersData = {
      ...(formData?.status && { status: formData?.status?.value }),
    };

    const filterBadgesData = {
      ...(formData?.status && {
        status: { label: 'Status', value: formData?.status?.label },
      }),
    };
    handleApplyFilter(applyFiltersData, filterBadgesData);
  };

  return (
    <HookForm onSubmit={onSubmit}>
      <h2 className='m-0'>Submission List Filters</h2>
      <dl className='my-5 space-y-5'>
        <div className='flex w-full justify-between items-center'>
          <dt>Status</dt>
          <dd className='w-2/3'>
            <HookReactSingleSelect name='status' options={statusChangeList} isClearable />
          </dd>
        </div>
      </dl>
      <div className='flex gap-4 justify-end pt-5'>
        <Button label='Cancel' btnStyle='btn-neutral' type='button' onClick={handleModal} />
        <Button label='Apply' btnStyle='primary' type='submit' />
      </div>
    </HookForm>
  );
};

export const CHDOFiltersForm = (props: ICHDOFiltersFormProps) => {
  return (
    <Modal customStyle='overflow-visible'>
      <HookFormProvider>
        <CHDOFiltersBaseForm {...props} />
      </HookFormProvider>
    </Modal>
  );
};
